import { Constant } from "../../webjam/constant";

const config = {
	socket_endpoint: Constant.App.ServerUrl,
};

export default config;
